import { isAxiosError } from 'axios'

/** The messages from a FastAPI validation refusal (`detail.errors[].error`), joined, if the error is one. */
export function validationErrorMessage(error: unknown): string | undefined {
  if (!isAxiosError(error)) return undefined
  const errors: unknown = error.response?.data?.detail?.errors
  if (!Array.isArray(errors)) return undefined
  const messages = errors.map(e => e?.error).filter((m): m is string => typeof m === 'string' && m !== '')
  return messages.length ? messages.join(' ') : undefined
}
